import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Select from 'react-select';
import { api_url, headers } from '../../common/config';
import close from '../../assets/images/icons/x_icn_pink.svg';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: '1px solid #c7d6f3',
        color: state.isSelected ? '#344567' : '#5c709c',
        backgroundColor: state.isSelected ? '#67ffe4' : 'white',
    }),
    control: (provided, state) => ({
        ...provided,
        width: '150px',
        borderRadius: '6px',
        border: '1.5px solid #c7d6f3',
        margin: '0 10px',
    }),
    menu: (provided, state) => ({
        ...provided,
        width: 150,
        borderRadius: '6px',
        margin: '0 10px',
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: '#5c709c',
    }),
    indicatorSeparator: () => ({}),
    singleValue: (provided, state) => ({
        color: '#344567',
        //   backgroundColor:'#67ffe4',
    }),
};

class Search extends Component {
    state = {
        search: '',
        searchError: '',
        centers: [],
        city: null,
        district: null,
        ministry: null,
        imageStatus: false,
    };
    validate = () => {
        const search = this.state.search;
        let searchError = '';
        if (!this.state.search) {
            return true;
        }
        if (typeof search == 'string') {
            // this regex Accepts all arabic & english litters Maximum length 30, spaces, and @ , = % $ # & _
            if (
                !search.match(
                    /^(?:[a-zA-Z0-9\s@,=%$#&_\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFF]|(?:\uD802[\uDE60-\uDE9F]|\uD83B[\uDE00-\uDEFF])){0,30}$/
                )
            ) {
                searchError = 'خطأ في الحقل';
            }
        }
        if (searchError) {
            this.setState({ searchError });
            return false;
        }
        return true;
    };

    handleImageLoaded = () => {
        this.setState({ imageStatus: true });
    };

    handleImageErrored = () => {
        this.setState({ imageStatus: 'failed to load' });
    };

    handleChange = (event) => {
        const { name, value } = event.target;

        this.setState({
            [name]: value,
            searchError: '',
        });
    };
    async componentDidMount() {
        await fetch(`${api_url}/autism/items/resources_page_centers`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    centers: res.data,
                });
            });
    }

    handleClick = () => {
        const search = this.state.search;
        const isValid = this.validate();
        if (isValid) {
            this.props.searchInput(search);
        } else {
            console.log(this.state.searchError);
        }
        this.setState({
            search: '',
        });
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleClick();
        }
    };

    handleCityChange = (value) => {
        if (value !== null) {
            this.props.filterCentersCity(value.label);
            this.setState({ city: value });
        }
    };

    handleDistrictChange = (value) => {
        if (value !== null) {
            this.props.filterCentersDistrict(value.label);
            this.setState({ district: value });
        }
    };

    handleMinistryChange = (value) => {
        if (value !== null) {
            this.props.filterCentersMinistry(value.label);
            this.setState({ ministry: value });
        }
    };

    handleClear = () => {
        this.setState({
            city: null,
            district: null,
            ministry: null,
            imageStatus: false,
        });
        this.props.filterCentersCity('');
        this.props.filterCentersDistrict('');
        this.props.filterCentersMinistry('');
    };

    render() {
        const { value, handleChange, a11yProps, TabPanel } = this.props;
        let cityOptions = this.state.centers.map((value) => {
            return value.city;
        });
        let districtOptions = this.state.centers.map((value) => {
            return value.state;
        });
        let ministryOptions = this.state.centers.map((value) => {
            return value.ministry;
        });
        let uniqueCityOptions = [...new Set(cityOptions)];
        let uniqueDistrictOptions = [...new Set(districtOptions)];
        let uniqueMinistryOptions = [...new Set(ministryOptions)];
        let values = ['value', 'label'];
        const cityOptionsObj = [];
        const districtOptionsObj = [];
        const ministryOptionsObj = [];
        for (var i = 0; i < uniqueCityOptions.length; i++) {
            var obj = {};
            for (var j = 0; j < values.length; j++) {
                obj[values[j]] = uniqueCityOptions[i];
            }
            cityOptionsObj.push(obj);
        }
        for (var i = 0; i < uniqueDistrictOptions.length; i++) {
            var obj = {};
            for (var j = 0; j < values.length; j++) {
                obj[values[j]] = uniqueDistrictOptions[i];
            }
            districtOptionsObj.push(obj);
        }
        for (var i = 0; i < uniqueMinistryOptions.length; i++) {
            var obj = {};
            for (var j = 0; j < values.length; j++) {
                obj[values[j]] = uniqueMinistryOptions[i];
            }
            ministryOptionsObj.push(obj);
        }

        let { city, district, ministry, t } = this.props;
        return (
            <div
                className={`search_container ${
                    i18next.language === 'en' ? 'en_search_container' : ''
                }`}
            >
                <h1>{t('blog.title')}</h1>

                <AppBar position='static'>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant='scrollable'
                        scrollButtons='off'
                        aria-label='scrollable prevent tabs example'
                    >
                        <Tab
                            label={`${t('blog.tabs.all')}`}
                            {...a11yProps(0)}
                            onClick={() => this.handleClear()}
                        />
                        <Tab
                            label={`${t('blog.tabs.centers')}`}
                            {...a11yProps(1)}
                        />
                        <Tab
                            label={`${t('blog.tabs.videos')}`}
                            {...a11yProps(2)}
                        />
                        <Tab
                            label={`${t('blog.tabs.research')}`}
                            {...a11yProps(3)}
                        />
                        <Tab
                            label={`${t('blog.tabs.articles')}`}
                            {...a11yProps(4)}
                        />
                    </Tabs>
                    {/* <div class='fadedScroller_tabs'></div> */}
                </AppBar>
                <div
                    className={`search_bar_container ${
                        i18next.language === 'en'
                            ? 'en_search_bar_container'
                            : ''
                    }`}
                >
                    <input
                        onChange={this.handleChange}
                        value={this.state.search}
                        name='search'
                        type='text'
                        placeholder={`${t('blog.searchText')}`}
                        onKeyPress={this.handleKeyPress}
                    />
                    <button onClick={this.handleClick}>
                        {t('blog.searchBtn')}
                    </button>
                </div>
                <div className='select_container'>
                    {value === 0 ? (
                        <></>
                    ) : (
                        <>
                            {value === 1 ? (
                                <>
                                    <div className='selected-filters'>
                                        <Select
                                            options={districtOptionsObj}
                                            // formatGroupLabel={formatGroupLabel}
                                            styles={customStyles}
                                            isRtl={true}
                                            isSearchable={false}
                                            placeholder={`${t(
                                                'blog.searchFilters.district'
                                            )}`}
                                            onChange={(district) =>
                                                this.handleDistrictChange(
                                                    district
                                                )
                                            }
                                            value={this.state.district}
                                        />
                                        <Select
                                            options={cityOptionsObj}
                                            // formatGroupLabel={formatGroupLabel}
                                            styles={customStyles}
                                            isRtl={true}
                                            isSearchable={false}
                                            placeholder={`${t(
                                                'blog.searchFilters.city'
                                            )}`}
                                            onChange={(city) => {
                                                this.handleCityChange(city);
                                            }}
                                            value={this.state.city}
                                        />
                                        <Select
                                            options={ministryOptionsObj}
                                            // formatGroupLabel={formatGroupLabel}
                                            styles={customStyles}
                                            isRtl={true}
                                            isSearchable={false}
                                            placeholder={`${t(
                                                'blog.searchFilters.ministry'
                                            )}`}
                                            onChange={(ministry) => {
                                                this.handleMinistryChange(
                                                    ministry
                                                );
                                            }}
                                            value={this.state.ministry}
                                        />
                                    </div>
                                    <div className='clear-filters'>
                                        {city !== '' ||
                                        district !== '' ||
                                        ministry !== '' ? (
                                            <div
                                                className={`selected-filter ${
                                                    this.state.imageStatus ===
                                                    true
                                                        ? 'show-clear'
                                                        : 'hide-clear'
                                                }`}
                                                onClick={() =>
                                                    this.handleClear()
                                                }
                                            >
                                                <img
                                                    src={close}
                                                    onLoad={
                                                        this.handleImageLoaded
                                                    }
                                                    onError={
                                                        this.handleImageErrored
                                                    }
                                                />
                                                {t('blog.emptyFilter')}
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <>
                                    {value === 2 ? (
                                        <></>
                                    ) : (
                                        <>
                                            {value === 3 ? (
                                                <></>
                                            ) : (
                                                <>
                                                    {value === 4 ? (
                                                        <></>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default withTranslation()(Search);
